export class SistemAlertsData {
  constructor(
    public readonly licensePlate: string,
    public readonly providerName: string,
    public readonly actualLocation: string,
    public readonly capacity: number | null,
    public readonly coverage: string,
    public readonly dlz: string,
    public readonly transportId: number
  ) {}
}
